import React from 'react'
import SVGInline from 'react-svg-inline'
import cx from 'classnames'

class Icon extends React.PureComponent {
  static defaultProps = {
    className: '',
    height: '24px',
    width: '24px'
  }

  render() {
    const { className, width, height, fill, cleanup } = this.props

    const svg = require(`../../images/icons/${this.props.type}.svg`)
    const classes = cx('icon', className)
    const style = { width, height, display: 'inline-block' }

    return React.createElement(SVGInline, {
      className: classes,
      svg,
      width,
      height,
      fill,
      style,
      cleanup
    })
  }
}

export default Icon



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/icon/index.js